import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from 'recharts'
import PageState from '../../components/PageState.jsx'
import { useApiData } from '../../hooks/useApiData.js'
import { getMetaOrganicHistory } from '../../db/api.js'

const formatDay = (value) => new Date(`${value}T12:00:00`).toLocaleDateString('pt-BR')
const groups = [
  ['Alcance e visualizações', [['reach', 'Alcance', '#6366f1'], ['views', 'Visualizações', '#0ea5e9']]],
  ['Interações', [['likes', 'Curtidas', '#ec4899'], ['comments', 'Comentários', '#6366f1'], ['shares', 'Compartilhamentos', '#f59e0b'], ['saves', 'Salvamentos', '#10b981']]],
  ['Visitas e ações no perfil', [['profile_views', 'Visitas ao perfil', '#8b5cf6'], ['profile_links_taps', 'Toques em links e ações', '#14b8a6']]],
]

function Chart({ title, rows, metrics }) {
  const available = rows.some(row => metrics.some(([key]) => row[key] != null))
  return <section className="bw-panel">
    <div className="bw-panel-head">{title}</div>
    <div className="bw-panel-body">
      {!available ? <p className="bw-panel-empty">A Meta não disponibilizou dados para este período.</p> :
        <div className="organic-history-chart">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={rows} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.4} />
              <XAxis dataKey="date" tickFormatter={formatDay} tick={{ fontSize: 11 }} tickLine={false} minTickGap={30} />
              <YAxis width={52} tick={{ fontSize: 11 }} tickLine={false} axisLine={false} allowDecimals={false} />
              <Tooltip labelStyle={{ fontSize: 12 }} labelFormatter={(value, payload) => {
                const end = payload?.[0]?.payload?.end
                return end && end !== value ? `${formatDay(value)} a ${formatDay(end)}` : formatDay(value)
              }} formatter={value => value == null ? 'Indisponível' : Number(value).toLocaleString('pt-BR')} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              {metrics.map(([key, name, color]) => <Line key={key} dataKey={key} name={name} stroke={color} strokeWidth={2} dot={{ r: 2 }} connectNulls={false} isAnimationActive={false} />)}
            </LineChart>
          </ResponsiveContainer>
        </div>}
    </div>
  </section>
}

export default function InstagramHistory({ pageId, start, end, cachedRead }) {
  const history = useApiData(() => cachedRead(JSON.stringify(['History', pageId, start, end]), () => getMetaOrganicHistory(pageId, start, end)), [pageId, start, end], { initialData: {}, skip: !pageId })
  if (!pageId) return null
  if (history.loading) return <div className="bw-panel-empty" role="status">Consultando histórico deste perfil na Meta…</div>
  if (history.error) return <PageState error={String(history.error)} onRetry={history.reload} />
  const data = history.data
  return <section aria-label="Histórico do Instagram">
    <p className="organic-history-caption">{data.bucket_days > 1 ? `Dados agrupados em intervalos de até ${data.bucket_days} dias.` : 'Dados por dia.'} Até o último dia completo, em UTC. Alcance representa contas únicas em cada intervalo, não deve ser somado entre intervalos.</p>
    {data.partial && <p role="status" className="organic-history-caption">Algumas métricas não foram disponibilizadas pela Meta. Lacunas não representam zero.</p>}
    <div className="organic-history-grid">
      {groups.map(([title, metrics]) => <Chart key={title} title={title} metrics={metrics} rows={data.series || []} />)}
      <Chart title="Novos seguidores · últimos 30 dias disponíveis no período" metrics={[["followers", "Novos seguidores", "#10b981"]]} rows={data.followers || []} />
    </div>
  </section>
}
